module.exports = __webpack_public_path__ + "static/media/squares.c13fe6be.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/squares.gif
// module id = 49
// module chunks = 5